export const sentryConfig = (environment: string) => ({
  dsn: 'https://914c855012aa442c81be3d2300eb13d2@sentry.wixpress.com/137',
  environment,
})
